var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeightCalorieCalculator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "weight_calorie_calculator") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "transparent_backgrounds",
    "data-name": "transparent backgrounds"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 600,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "weight_calorie_calculator"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 37.22,
    width: 524.55,
    height: 599.49,
    rx: 51.27,
    fill: "#00d89a"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.87,
    y: 66.68,
    width: 374.68,
    height: 151.95,
    rx: 24,
    fill: "#e1ffe1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.87,
    y: 297.09,
    width: 74.94,
    height: 74.94,
    rx: 12,
    fill: "#7effaa"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.74,
    y: 297.09,
    width: 74.94,
    height: 74.94,
    rx: 12,
    fill: "#7effaa"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.74,
    y: 446.97,
    width: 74.94,
    height: 74.94,
    rx: 12,
    fill: "#7effaa"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412.61,
    y: 297.09,
    width: 74.94,
    height: 224.81,
    rx: 12,
    fill: "#7effaa"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.87,
    y: 446.97,
    width: 74.94,
    height: 74.94,
    rx: 12,
    fill: "#7effaa"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeightCalorieCalculator);
export default __webpack_public_path__ + "static/media/weight_calorie_calculator.eb0358c31bff772e99776339bd22da53.svg";
export { ForwardRef as ReactComponent };